/*eslint-disable*/
import { Button, Icon, LinearProgress } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons
import AttachMoney from "@material-ui/icons/AttachMoney";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import SpaceDisplay from "components/SpaceDisplay/SpaceDisplay.jsx";
import { GetUserId, GetUserToken } from "helpers/UserHelper";
import { SubscriptionInfo } from "queries/Subscription/queries";
import React, { Component } from "react";
import { Query } from "react-apollo";

const PricePlanMap = {
  1: "Basic",
  2: "Standard",
  3: "Premium",
  4: "Trial"
};

class Subscription extends Component {
  render() {
    return (
      <Query
        query={SubscriptionInfo}
        variables={{
          userId: GetUserId(),
          token: GetUserToken()
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data, refetch }) => {
          if (loading) {
            return <LinearProgress />;
          }
          var subscriptionInfo = data.SubscriptionInfo;

          return (
            <React.Fragment>
              <GridContainer>
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ marginBottom: "20px" }}
                >
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ margin: "0px auto" }}
                  >
                    <Card style={{ paddingBottom: "50px", paddingTop: "25px" }}>
                      <CardHeader>
                        <CardIcon
                          color="sqLightBlue"
                          className="cardIconTopRight"
                        >
                          <AttachMoney style={{ color: "white" }} />
                        </CardIcon>
                        <Typography variant="headline" className="centerCell">
                          Your Subscription
                        </Typography>
                        <div
                          style={{
                            borderBottom: "1px solid #cccccc69",
                            paddingBottom: "12px",
                            margin: "10px auto",
                            width: "65%"
                          }}
                        />
                      </CardHeader>
                      <GridItem
                        xs={12}
                        sm={10}
                        md={10}
                        style={{
                          display: "grid",
                          margin: "0px auto",
                          width: "100%"
                        }}
                      >
                        <SpaceDisplay
                          left={
                            <Typography>Your Current Price Plan :</Typography>
                          }
                          right={
                            <Typography>
                              {
                                PricePlanMap[
                                  subscriptionInfo.sd_brokerage_user_plan
                                ]
                              }
                            </Typography>
                          }
                        />

                        <SpaceDisplay
                          left={<Typography>Current Price :</Typography>}
                          right={
                            <Typography>
                              {subscriptionInfo.sd_price_pm} p/m
                            </Typography>
                          }
                        />

                        <SpaceDisplay
                          left={<Typography>Next Payment :</Typography>}
                          right={
                            <Typography>
                              {subscriptionInfo.sd_next_payment}
                            </Typography>
                          }
                        />

                        <Typography
                          variant="subheading"
                          style={{
                            float: "left",
                            textAlign: "left",
                            margin: "20px 0px",
                            textAlign: "center"
                          }}
                        >
                          <strong>Brokers</strong>
                        </Typography>

                        <SpaceDisplay
                          left={<Typography>Basic:</Typography>}
                          right={
                            <Typography>
                              {subscriptionInfo.sd_basic_brokers}
                            </Typography>
                          }
                        />

                        <SpaceDisplay
                          left={<Typography>Standard :</Typography>}
                          right={
                            <Typography>
                              {subscriptionInfo.sd_standard_brokers}
                            </Typography>
                          }
                        />

                        <SpaceDisplay
                          left={
                            <Typography>
                              <strong>Total:</strong>
                            </Typography>
                          }
                          right={
                            <Typography>
                              {subscriptionInfo.sd_basic_brokers +
                                subscriptionInfo.sd_standard_brokers}
                            </Typography>
                          }
                        />

                        <SpaceDisplay
                          style={{
                            margin: "20px 0px"
                          }}
                          left={<Typography>Assistants :</Typography>}
                          right={
                            <Typography>
                              {subscriptionInfo.sd_free_assistants +
                                subscriptionInfo.sd_extra_assistants}
                            </Typography>
                          }
                        />
                      </GridItem>

                      <GridItem
                        xs={12}
                        sm={10}
                        md={6}
                        style={{
                          display: "grid",
                          margin: "0px auto",
                          width: "100%"
                        }}
                      >
                        <div style={{ marginTop: "30px" }}>
                          <Button
                            fullWidth
                            variant="outlined"
                            className="outlinedButton"
                            className="outlinedButton"
                            color="secondary"
                            style={{
                              float: "left",
                              marginBottom: "15px"
                            }}
                            onClick={() =>
                              this.props.history.push("/app/editsubscription")
                            }
                          >
                            Edit Subscription
                            <Icon style={{ margin: "5px" }}>edit</Icon>
                          </Button>
                        </div>
                      </GridItem>
                      <Typography
                        variant="caption"
                        style={{
                          position: "absolute",
                          bottom: "5px",
                          right: "12px",
                          color: "#0000008a"
                        }}
                        className="typographyLinkBasic"
                      >
                        Want to cancel your subscription?
                      </Typography>
                    </Card>
                  </GridItem>
                </GridItem>
              </GridContainer>
            </React.Fragment>
          );
        }}
      </Query>
    );
  }
}

export default Subscription;



// WEBPACK FOOTER //
// ./src/views/Subscription/Subscription.jsx